import axios from 'axios'

// Cookie-based auth works best when API is same-origin via Vite/nginx proxying `/api`.
// Always use relative baseURL here to avoid CORS/SameSite/CSP surprises.
const API_BASE_URL = ''

// Create a shared axios instance with common configuration
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
})

// Add response interceptor to handle token refresh
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // Never attempt refresh when the refresh request itself fails (prevents infinite loops).
    // Also, only retry each request once.
    if (
      error.response?.status === 401 &&
      !originalRequest?._retry &&
      !String(originalRequest?.url || '').includes('/api/v1/auth/refresh')
    ) {
      originalRequest._retry = true

      try {
        // Cookie-based refresh (HttpOnly refresh token)
        await apiClient.post('/api/v1/auth/refresh')
        return apiClient(originalRequest)
      } catch (refreshError) {
        // Refresh failed:
        // - For public pages, do NOT force redirect. They are accessible without login.
        // - For dashboard pages, redirect to login so the user can re-auth.
        if (window.location.pathname.startsWith('/dashboard')) {
          window.location.href = '/auth/login'
        }
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)